import { Grid, InputAdornment, TextField } from "@mui/material";
import logo from "../../../assets/images/logo.png";
import NavSection from "../navs/NavSection";
import { sidebarConfig } from "./SidebarConfig";

export default function SidebarContent(props) {
  const { searchTerm, setSearchTerm } = props;

  const filteredMenuItems = sidebarConfig.filter(
    (item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.children &&
        item.children.some((child) =>
          child.title.toLowerCase().includes(searchTerm.toLowerCase())
        ))
  );

  return (
    <div>
      <div className="d-flex justify-content-center p-4 pb-0 pt-0">
        <img
          src={logo}
          className="my-3"
          alt="Admin Portal Logo"
          style={{ width: "68%", height: "57px", filter: "invert(1)" }}
        />
      </div>
      <Grid
        sx={{ p: 1, mt: 0, ml: 0.7, display: "flex", justifyContent: "center" }}
      >
        <TextField
          variant="outlined"
          placeholder="Search..."
          autoComplete="off"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start"></InputAdornment>,
          }}
          InputLabelProps={{
            sx: {},
          }}
          sx={{
            marginRight: "auto",
            "& .MuiOutlinedInput-root": {
              borderRadius: "7px",
              height: "40px",
              width: "240px",
            },
          }}
        />
      </Grid>
      <NavSection navConfig={filteredMenuItems} />
    </div>
  );
}
